module.exports = __webpack_public_path__ + "static/media/loc5_img1.c563d3d2.png";